import React from 'react';
import { secureWebComponents } from '../helpers/secureWebComponents.js';
const StatusIndicator = secureWebComponents(({
  type = StatusIndicator.success
}) => /*#__PURE__*/React.createElement("ebds-status-indicator", {
  type: type
}));
StatusIndicator.types = {
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  neutral: 'neutral'
};
export default StatusIndicator;